<template>
  <section class="solution">
    <h2 class="section-title">解决方案</h2>
    <p class="subtitle">破解球房经营痛点</p>

    <div class="solution-content">
      <div class="solution-wrapper">
        <div class="solution-cards">
          <div class="solution-card traditional">
            <h3>传统困境</h3>
            <ul>
              <li>开台率低，时段营收不均</li>
              <li>年轻客群流失，粘性不足</li>
              <li>同质化竞争激烈</li>
            </ul>
          </div>

          <div class="solution-card innovative">
            <h3>奇点解决方案</h3>
            <ul>
              <li>AI 动态定价 + 闲时灯光秀</li>
              <li>成长体系 + 社交排行榜</li>
              <li>"会说话的球桌" 网红标签</li>
            </ul>
          </div>
        </div>
        
        <div class="solution-carousel">
          <div class="carousel-container">
            <div class="carousel-track" :style="{ transform: `translateX(${currentPosition}px)` }">
              <div v-for="(image, index) in images" :key="index" class="carousel-slide">
                <img :src="image" :alt="'解决方案图片 ' + (index + 1)">
              </div>
              <!-- 重复第一张图片用于无缝循环 -->
              <div class="carousel-slide">
                <img :src="images[0]" alt="解决方案图片 1">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Solution',
  data() {
    return {
      images: [
        require('@/assets/solution/1.png'),
        require('@/assets/solution/3.png'),
        require('@/assets/solution/2.png'),
        require('@/assets/solution/4.png')
      ],
      currentPosition: 0,
      slideWidth: 300, // 每张图片的宽度，可以根据需要调整
      intervalId: null
    }
  },
  mounted() {
    this.updateSlideWidth()
    this.intervalId = setInterval(this.moveSlide, 20) // 5秒内滚动完，更快的滚动速度
    window.addEventListener('resize', this.updateSlideWidth)
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
    window.removeEventListener('resize', this.updateSlideWidth)
  },
  methods: {
    updateSlideWidth() {
      // 根据屏幕尺寸动态调整滑动宽度，保持图片原始比例
      if (window.innerWidth <= 480) {
        this.slideWidth = 200
      } else if (window.innerWidth <= 768) {
        this.slideWidth = 280
      } else {
        this.slideWidth = 350
      }
    },
    moveSlide() {
      // 动态计算移动距离：5秒内滚动完4张图片
      // 5秒 = 5000ms，间隔20ms，共250次移动
      const totalDistance = this.slideWidth * 4
      const moveDistance = totalDistance / 800
      
      this.currentPosition -= moveDistance
      // 当滚动完4张图片的距离时重置，实现无缝循环
      if (this.currentPosition <= -totalDistance) {
        this.currentPosition = 0
      }
    }
  }
}
</script>

<style scoped>
.solution {
  padding: 4rem 5%;
  background-color: #f8f9fa;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.subtitle {
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.solution-content {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.solution-wrapper {
  position: relative;
}

.solution-cards {
  display: flex;
  gap: 2rem;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.solution-card {
  flex: 1;
  background: #fff;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  max-width: 400px;
}

.solution-carousel {
  position: relative;
  margin-top: 20px;
  z-index: 2;
}

.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
}

.carousel-track {
  display: flex;
  position: relative;
}

.carousel-slide {
  flex: 0 0 350px; /* 增大容器宽度以容纳原始图片 */
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-slide img {
  max-width: none; /* 移除宽度限制，显示原始图片大小 */
  height: auto;
  border-radius: 8px;
  object-fit: contain;
}



.solution-card h3 {
  font-size: 1.3rem;
  margin-bottom: 1.2rem;
  color: #333;
}

.solution-card.traditional h3 {
  color: #666;
}

.solution-card.innovative h3 {
  color: #ff0000;
}

.solution-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.solution-card li {
  position: relative;
  padding-left: 1.5rem;
  margin-bottom: 0.8rem;
  color: #666;
  line-height: 1.5;
}

.solution-card li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #ff0000;
}

@media (max-width: 768px) {
  .solution {
    padding: 3rem 4%;
  }

  .section-title {
    font-size: 2rem;
    margin-bottom: 0.8rem;
  }

  .subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .solution-cards {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }

  .solution-card {
    width: 100%;
    max-width: 100%;
    padding: 1.2rem;
  }

  .solution-card h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    text-align: center;
  }

  .solution-card li {
    font-size: 0.95rem;
    margin-bottom: 0.7rem;
    padding-left: 1.2rem;
  }

  .carousel-slide {
    flex: 0 0 280px; /* 移动端适当缩小但保持原始比例 */
    padding: 0 8px;
  }

  .carousel-slide img {
    max-width: 260px; /* 移动端限制最大宽度但保持原始比例 */
    width: auto;
  }


}

@media (max-width: 480px) {
  .solution {
    padding: 2rem 3%;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .subtitle {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }

  .solution-card {
    padding: 1rem;
  }

  .solution-card h3 {
    font-size: 1.1rem;
  }

  .solution-card li {
    font-size: 0.9rem;
    margin-bottom: 0.6rem;
  }

  .carousel-slide {
    flex: 0 0 200px; /* 小屏幕适配，保持图片可见性 */
    padding: 0 6px;
  }

  .carousel-slide img {
    max-width: 180px; /* 小屏幕限制最大宽度 */
    width: auto;
  }
}
</style>
